import { getMarketingBulletsItems } from './element-type-components/marketing-bullets';
import { getProsAndConsItems } from './element-type-components/pros-and-cons';
import { getRewardsRatesItems } from './element-type-components/rewards-rates';
import { getPersonalLoansItems } from './element-type-components/personal-loans';
import type { BulletListItem } from './types';
import type { PersonalLoansItems } from './element-type-components/personal-loans';

export const getMarketplaceOfferItems = (
  marketplaceOfferId: string,
  elementType: string,
  marketplaceOffers: any[]
): BulletListItem[] | PersonalLoansItems | undefined => {
  let items;

  const selectedOffer = marketplaceOffers?.find(
    (offer: any) => offer.id === marketplaceOfferId
  );

  if (selectedOffer && elementType === 'prosAndCons') {
    items = getProsAndConsItems(selectedOffer);
  }

  if (selectedOffer && elementType === 'rewardsRates') {
    items = getRewardsRatesItems(selectedOffer);
  }

  if (selectedOffer && elementType === 'marketingBullets') {
    items = getMarketingBulletsItems(selectedOffer);
  }

  if (selectedOffer && elementType === 'personalLoans') {
    items = getPersonalLoansItems(selectedOffer);
  }

  return items;
};
